// extracted by css-extract-rspack-plugin
export default {"modal":"sPTI2S","form":"vV4PHh","body":"Oy1aLU","heading":"OYEXmi","field":"U1Lo0L","actions":"PEeFZZ","buttonIcon":"VcWCPr"};